import React, {  useEffect, useState } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'animate.css'
import medicine from '../assets/Images/Banner medical-treatment.jpg'
import shapeHome from '../assets/Images/shapes/HomebannerThread-01.png'
import topImg from "../assets/Images/WEBSITE IMAGE 01.jpg"
import hospitalimg from "../assets/Images/WEBSITE IMAGE 2.jpg"
import BookAppointmentDialog from './BookAnAppointmentDialogue'
import { Link } from 'react-router-dom'
export default function HomeBanner() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true
    })
  }, [])
  return (
    <div>
      <section className='bg-white pb-4'>
        <div className='container mx-auto  px-10 lg:px-[24px] xl:px-0 2xl:px-32 relative'>
          <div
            className='grid grid-cols-1 lg:grid-cols-[1fr_1.25fr] gap-10  relative pt-20 z-10  items-center justify-center'
            data-aos='fade-up'
          >
            {/* Left Content */}
            <div className='space-y-6'>
              <h1 className='text-[36px] md:text-[48px] lg:text-[58px] font-heading text-thickGreen leading-[1.138em]'>
                We at{' '}
                <span className='text-orange  drop-shadow-sm'>MagnAid</span> <br />
                are there for you{' '}
                <span className='text-lightGreen tracking-wide'>ALWAYS</span> and in{' '}
                <span className='text-lightGreen tracking-wide'>ALL WAYS</span>
              </h1>
              <p className='text-[17px] font-[300] text-paraGreen leading-[1.667em] font-body mb-[32px]'>
                We are the best multispecialty hospital in Hyderabad with
                cutting-edge technologies to ensure the safety of our patients
                with optimal care.
              </p>
              <div className='sm:block md:flex md:space-x-4 space-y-4 md:space-y-0'>
                <button
                  onClick={handleOpenDialog}
                  className='bg-orange text-white w-full md:w-[50%] px-6 py-6 rounded-full font-medium  font-body text-[20px] leading-[1.112em] 
       transition-all duration-300 hover:bg-lightGreen  hover:bg-opacity-90 
       hover:translate-y-[-3px] block md:inline-block text-center'
                >
                  Book an Appointment
                </button>

                <Link
                  to='/our-medical-services'
                  className='text-thickGreen w-full md:w-[50%] px-6 py-6 rounded-full font-medium border border-thickGreen bg-transparent md:flex justify-center items-center 
       hover:bg-orange hover:text-white hover:border-none text-[20px] leading-[1.112em] z-50  transition-all duration-300 hover:translate-y-[-3px] 
       block sm:inline-block text-center font-body'
                >
                  Our Specialities
                </Link>
              </div>
            </div>

            {/* Right Side Images */}
            <div className='relative mb-[-80px] grid grid-cols-[0.8fr_1fr] gap-3 md:gap-8 items-end z-[1]'>
              <img
                src={medicine}
                alt='Healthcare Drugs'
                className='w-[100%] rounded-[8px] md:rounded-[24px] shadow-md mt-24'
              />
              <img
                src={topImg}
                alt='Portrait Doctor'
                className='w-full rounded-[8px] md:rounded-[24px] shadow-md'
              />
              <img
                src={hospitalimg}
                alt='Phone Medical Appointment'
                className='w-[82%] md:w-[62%] rounded-[8px] md:rounded-[24px] shadow-md col-span-2 mx-auto'
              />
              <div className='absolute w-[130%] top-[-2%] right-[-14%] z-[-1] animate__animated animate__fadeIn animate__delay-1s'>
                <img
                  src={shapeHome}
                  loading='eager'
                  alt='shape'
                  className='w-full'
                />
              </div>
            </div>
          </div>
          {/* Background Shape */}
          <div className='absolute inset-y-0 right-0 w-[100vw]  mr-0 md:mr-[2.3%] lg:mr-[7.3%] 2xl:mr-[15.3%] bg-verylightGreen md:rounded-tr-[24px] md:rounded-br-[24px] z-0 '></div>
        </div>
        <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
      </section>
    </div>
  )
}
